import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import EditClaim from "./EditClaim";
import {withRouter} from "react-router";
import i18next from "i18next";

class CreateClaimExternal extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditClaim: false,
            currentClaimKey: null
        }
    }

    componentDidMount() {
    }

    createClaim = async (e, claimType) => {
        try {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            await confirm(i18next.t("Request_Create_Confirm"));
            await this.props.dispatch(this.props.dataItem.execute({TypeClaimPersId: claimType}, {withParams: false}))
            if (!this.props.dataItem.isError) {
                const claimKey = this.props.dataItem.getRow(0);
                this.setState({showEditClaim: true, currentClaimKey: claimKey});
            }
        } catch {
        }
    }

    hideEditClaim = (success = false) => {

        this.setState({showEditClaim: false});

        /*
        if (!success)
            return;

        this.props.history.push("/Claim");
         */
    }

    getMenu() {
        return this.props.menu.Items.find(mi => mi.MenuID === this.props.claimMenuId && mi.IsVisible);
    }

    render() {
        const menuItem = this.getMenu();

        if (menuItem === undefined || !menuItem.IsVisible)
            return null;

        const claimType = menuItem?.AppCommand?.CommandParams?.ClaimType;

        return (<>
            <button type="button" className="btn btn-regular -default" style={this.props.style}
                    onClick={(e) => this.createClaim(e, claimType)}>{menuItem.Text}</button>
            {this.state.showEditClaim &&
            <EditClaim onClose={this.hideEditClaim} claimKey={this.state.currentClaimKey}/>}
        </>)
    }


}

CreateClaimExternal.propTypes = {
    dispatch: PropTypes.func.isRequired,
    claimMenuId: PropTypes.string.isRequired,
    menu: PropTypes.object
};


CreateClaimExternal.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        menu: state.appState.appParams.menu,
        dataItem: state.claimState.ClaimPersNewOneClaimForPO
    }
}

export default withRouter(connect(mapStateToProps)(CreateClaimExternal))